import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tip-modal',
  templateUrl: './tip-modal.component.html',
  styleUrls: ['./tip-modal.component.scss'],
})
export class TipModalComponent {
  constructor(
    private modalRef: MatDialogRef<TipModalComponent>,
    private router: Router
  ) {}

  goto() {
    this.modalRef.close();
    this.router.navigateByUrl('/user/profile');
  }
}
